import React, { useState } from "react";

export default function Achievements() {
  const [lightbox, setLightbox] = useState<string | null>(null);

  // Auto-generate 001 → 020
  const achievements = Array.from({ length: 20 }, (_, i) => {
    const num = String(i + 1).padStart(3, "0");
    return {
      id: num,
      img: `/images/achivements/${num}.jpg`,
      title: ``,
      org: "",
      year: "",
    };
  });

  return (
    <section
      id="achievements"
      className="py-24 md:py-32 relative"
      style={{ background: "#0F1629" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <h2
            className="text-white font-bold mb-4"
            style={{ fontSize: "clamp(2rem,3.5vw,3rem)" }}
          >
            Our <span style={{ color: "#C8A84B" }}>Achievements</span>
          </h2>
          <p
            style={{
              color: "rgba(212,207,197,0.6)",
              maxWidth: "480px",
              margin: "0 auto",
            }}
          >
            Over two decades of excellence and recognition.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {achievements.map((ach) => (
            <div
              key={ach.id}
              className="rounded-sm overflow-hidden cursor-pointer group bg-[#111827]"
              onClick={() => setLightbox(ach.img)}
            >
              <div className="h-[220px] overflow-hidden">
                <img
                  src={ach.img}
                  alt={ach.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>

              <div className="p-4">
                <div className="text-white font-semibold text-sm mb-1">
                  {ach.title}
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-400">
                    {ach.org}
                  </span>

                  {/* <span
                    className="px-2 py-0.5 text-[10px] font-bold rounded-sm"
                    style={{
                      background: "rgba(200,168,75,0.1)",
                      color: "#C8A84B",
                      border: "1px solid rgba(200,168,75,0.2)",
                    }}
                  >
                    {ach.year}
                  </span> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center p-6"
          style={{
            background: "rgba(0,0,0,0.9)",
            backdropFilter: "blur(8px)",
          }}
          onClick={() => setLightbox(null)}
        >
          <div className="relative max-w-5xl w-full">
            <button
              className="absolute -top-12 right-0 text-white text-3xl font-bold"
              onClick={() => setLightbox(null)}
            >
              ✕
            </button>

            <img
              src={lightbox}
              alt="Certificate"
              className="w-full max-h-[85vh] object-contain rounded-sm"
            />
          </div>
        </div>
      )}
    </section>
  );
}